import { lazy } from 'react'
import type { RouteObject } from 'react-router'
import { Outlet } from 'react-router-dom'
import { wrapWithErrorBoundary } from './wrapWithErrorBoundary'

const AccountPage = lazy(() => import('@/pages/account'))

const WrappedAccountPage = wrapWithErrorBoundary(AccountPage)

export const accountNestedRoute: RouteObject = {
  path: 'account',
  element: <Outlet />,
  children: [
    {
      index: true,
      element: <WrappedAccountPage />,
      handle: {
        documentTitle: { namespace: 'nav', key: 'account' },
      },
    },
  ],
}
